import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
} from "react-icons/si";
import { SiJupyter } from "react-icons/si";
import { FaJira } from "react-icons/fa";
import { SiPowerbi } from "react-icons/si";
import { SiMysql } from "react-icons/si";
import { SiMicrosoftpowerpoint } from "react-icons/si";
import { SiMicrosoftvisio } from "react-icons/si";
import { FaConfluence } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import { SiMiro } from "react-icons/si";
import { IoLogoTableau } from "react-icons/io5";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiJupyter />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaJira />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPowerbi />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftpowerpoint />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMicrosoftvisio />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaConfluence />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaFileExcel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaReact  />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMiro  />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <IoLogoTableau   />
      </Col>
    </Row>
  );
}

export default Toolstack;